import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './simple-card.scss.js';
import { getStyleClassNames } from '../../utilities/constants/styles.constants.js';

class SimpleCard extends s {
    constructor() {
        super(...arguments);
        this.isRtl = false;
        this.padding = '1em';
        this.withBorder = false;
        this.borderRadius = '0.5em';
        this.width = 0;
        this.additionalClasses = '';
        this.link = '';
    }
    render() {
        const cardClassNames = getStyleClassNames({
            padding: this.padding,
            borderRadius: this.borderRadius,
            withBorder: this.withBorder,
            isRtl: this.isRtl,
            additionalClasses: this.additionalClasses,
        });
        let widthStyle;
        if (this.width === 0) {
            widthStyle = 'unset';
        }
        else {
            widthStyle = this.width > 100 ? `${this.width}px` : `${this.width}%`;
        }
        if (this.link) {
            return x `<a href="${this.link}" class="linked-card"><div class="simple-card ${cardClassNames}" style="width:${widthStyle}"><slot></slot></div></a>`;
        }
        return x `<div class="simple-card ${cardClassNames}" style="width:${widthStyle}"><slot></slot></div>`;
    }
}
SimpleCard.styles = css_248z;
__decorate([
    n({ type: Boolean })
], SimpleCard.prototype, "isRtl", void 0);
__decorate([
    n({ type: String })
], SimpleCard.prototype, "padding", void 0);
__decorate([
    n({ type: Boolean })
], SimpleCard.prototype, "withBorder", void 0);
__decorate([
    n({ type: String })
], SimpleCard.prototype, "borderRadius", void 0);
__decorate([
    n({ type: Number })
], SimpleCard.prototype, "width", void 0);
__decorate([
    n({ type: String })
], SimpleCard.prototype, "additionalClasses", void 0);
__decorate([
    n({ type: String })
], SimpleCard.prototype, "link", void 0);
customElements.define('simple-card', SimpleCard);

export { SimpleCard };
